<nb-card>
  <nb-card-header class="infor-header">
    <div class="d-flex justify-content-between">
      Testing QR Code
      <button
        (click)="dismiss()"
        type="button"
        class="btn-close"
        aria-label="Close"
      ></button>
    </div>
  </nb-card-header>
  <nb-card-body style="width: 500px; padding-top: 0">
    <nb-tabset fullWidth>
      <nb-tab tabTitle="Chat Bot">
        <div
          class="qrcodeImage center"
          style="
            width: 100%;
            flex-direction: column;
            align-items: center;
            margin-bottom: 1rem;
          "
        >
          <qrcode
            id="webchat-qr"
            [qrdata]="testChatUrl"
            [allowEmptyString]="true"
            [ariaLabel]="'QR Code image with the following content...'"
            [cssClass]="'center'"
            [colorDark]="'#000000ff'"
            [colorLight]="'#ffffffff'"
            [elementType]="'canvas'"
            [errorCorrectionLevel]="'M'"
            [imageSrc]="logoDefault"
            [imageHeight]="50"
            [imageWidth]="50"
            [margin]="4"
            [scale]="1"
            [title]="testChatUrl"
            [width]="200"
            (qrCodeURL)="onChangeURL($event)"
          ></qrcode>
          <div style="display: flex; gap: 0.5rem">
            <div class="downloadButton">
              <button
                matTooltip="Download QR Code image"
                nbButton
                type="button"
                status="primary"
                (click)="saveAsImage('#webchat-qr')"
              >
                Download QR Code
                <nb-icon icon="download-outline"></nb-icon>
              </button>
            </div>
            <div>
              <a
                [href]="testChatUrl"
                target="_blank"
                rel="noopener noreferrer"
                style="display: block; width: 100%; height: 100%"
              >
                <button
                  matTooltip="Open link"
                  nbButton
                  status="basic"
                  outline
                  style="height: 100%"
                  size="small"
                  class="copy-button"
                >
                  Open link
                  <nb-icon icon="external-link-outline"></nb-icon></button
              ></a>
            </div>
          </div>
        </div>
        <form
          [formGroup]="botForm"
          novalidate
          class="step-container"
          style="margin-bottom: 1rem"
        >
          <div class="input-group">
            <div class="form-control-container" style="width: 100%">
              <label class="form-label label">Bot Name</label>
              <input
                type="text"
                nbInput
                autofocus
                #inputName
                formControlName="name"
                maxlength="100"
                (input)="updateBotName($event)"
                [(ngModel)]="botName"
                [status]="
                  botForm.controls['name'].invalid &&
                  (botForm.controls['name'].dirty ||
                    botForm.controls['name'].touched)
                    ? 'danger'
                    : 'basic'
                "
                fullWidth
                id="input-name"
                placeholder="Bot Name"
                style="margin-bottom: 0.25rem"
                fieldSize="medium"
              />
              <ng-container
                *ngIf="
                  botForm.controls['name'].invalid &&
                  (botForm.controls['name'].dirty ||
                    botForm.controls['name'].touched)
                "
              >
                <p
                  class="caption status-danger"
                  style="margin-bottom: 0"
                  *ngIf="
                    botForm.controls['name'].hasError('required') ||
                    botForm.controls['name'].hasError('whitespace')
                  "
                >
                  Bot Name is required.
                </p>
                <p
                  class="caption status-danger"
                  style="margin-bottom: 0"
                  *ngIf="
                    botForm.controls['name'].errors.maxlength &&
                    !botForm.controls['name'].hasError('required') &&
                    !botForm.controls['name'].hasError('whitespace')
                  "
                >
                  Maximum length is 50 characters.
                </p>
              </ng-container>
            </div>
          </div>
        </form>
        <div
          class="label-script"
          style="display: flex; gap: 0.5rem; flex-direction: column"
        >
          <label class="label" style="align-self: flex-start">
            Test Chat Link
          </label>
          <nb-form-field style="width: 100%">
            <input nbInput fullWidth [(ngModel)]="testChatUrl" readonly />
            <button
              nbSuffix
              nbButton
              ghost
              matTooltip="Copy"
              (click)="copy(testChatUrl)"
            >
              <nb-icon icon="copy"></nb-icon>
            </button>
          </nb-form-field>
        </div>
      </nb-tab>
      <nb-tab tabTitle="Voice Bot" [active]="activeTab === 1">
        <div
          class="qrcodeImage center"
          style="
            width: 100%;
            flex-direction: column;
            align-items: center;
            margin-bottom: 1rem;
          "
        >
          <qrcode
            id="call-qr"
            [qrdata]="testCallUrl"
            [allowEmptyString]="true"
            [ariaLabel]="'QR Code image with the following content...'"
            [cssClass]="'center'"
            [colorDark]="'#000000ff'"
            [colorLight]="'#ffffffff'"
            [elementType]="'canvas'"
            [errorCorrectionLevel]="'M'"
            [imageSrc]="logoDefault"
            [imageHeight]="50"
            [imageWidth]="50"
            [margin]="4"
            [scale]="1"
            [title]="testCallUrl"
            [width]="200"
            (qrCodeURL)="onChangeURL($event)"
          ></qrcode>
          <div style="display: flex; gap: 0.5rem">
            <div class="downloadButton">
              <button
                matTooltip="Download QR Code image"
                nbButton
                type="button"
                status="primary"
                (click)="saveAsImage('#call-qr')"
              >
                Download QR Code
                <nb-icon icon="download-outline"></nb-icon>
              </button>
            </div>
            <div>
              <a
                [href]="testCallUrl"
                target="_blank"
                rel="noopener noreferrer"
                style="display: block; width: 100%; height: 100%"
              >
                <button
                  matTooltip="Open link"
                  nbButton
                  status="basic"
                  outline
                  style="height: 100%"
                  size="small"
                  class="copy-button"
                >
                  Open link
                  <nb-icon icon="external-link-outline"></nb-icon></button
              ></a>
            </div>
          </div>
        </div>
        <form
          [formGroup]="botForm"
          novalidate
          class="step-container"
          style="margin-bottom: 1rem"
        >
          <div class="input-group">
            <div class="form-control-container" style="width: 100%">
              <label class="form-label label">Bot Name</label>
              <input
                type="text"
                nbInput
                autofocus
                #inputName
                formControlName="name"
                maxlength="100"
                (input)="updateBotName($event)"
                [(ngModel)]="botName"
                [status]="
                  botForm.controls['name'].invalid &&
                  (botForm.controls['name'].dirty ||
                    botForm.controls['name'].touched)
                    ? 'danger'
                    : 'basic'
                "
                fullWidth
                id="input-name"
                placeholder="Bot Name"
                style="margin-bottom: 0.25rem"
                fieldSize="medium"
              />
              <ng-container
                *ngIf="
                  botForm.controls['name'].invalid &&
                  (botForm.controls['name'].dirty ||
                    botForm.controls['name'].touched)
                "
              >
                <p
                  class="caption status-danger"
                  style="margin-bottom: 0"
                  *ngIf="
                    botForm.controls['name'].hasError('required') ||
                    botForm.controls['name'].hasError('whitespace')
                  "
                >
                  Bot Name is required.
                </p>
                <p
                  class="caption status-danger"
                  style="margin-bottom: 0"
                  *ngIf="
                    botForm.controls['name'].errors.maxlength &&
                    !botForm.controls['name'].hasError('required') &&
                    !botForm.controls['name'].hasError('whitespace')
                  "
                >
                  Maximum length is 50 characters.
                </p>
              </ng-container>
            </div>
          </div>
        </form>
        <div
          class="label-script"
          style="display: flex; gap: 0.5rem; flex-direction: column"
        >
          <label class="label" style="align-self: flex-start">
            Test Call Link
          </label>
          <nb-form-field style="width: 100%">
            <input nbInput fullWidth [(ngModel)]="testCallUrl" readonly />
            <button
              nbSuffix
              nbButton
              ghost
              matTooltip="Copy"
              (click)="copy(testCallUrl)"
            >
              <nb-icon icon="copy"></nb-icon>
            </button>
          </nb-form-field>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
